import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Linkedin, Music2, Twitter } from "lucide-react";
import Logo from "./Logo";
import { SITE, NAV } from "../../data";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  return (
    <footer className="bg-[#111827] text-white">
      <div className="h-1.5 w-full flex">
        <span className="flex-1 bg-espana-red" />
        <span className="flex-1 bg-espana-gold" />
        <span className="flex-1 bg-espana-red" />
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <Logo light />
            <p className="mt-5 text-sm text-white/60 max-w-xs leading-relaxed">
              {SITE.slogan}. Iniciativa independiente de reforma política,
              administrativa y tecnológica.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href={SITE.social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-tiktok"
                aria-label="TikTok"
                className="h-10 w-10 flex items-center justify-center border border-white/20 hover:bg-espana-red hover:border-espana-red transition-colors"
              >
                <Music2 size={18} />
              </a>
              <a
                href={SITE.social.x}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-x"
                aria-label="X (Twitter)"
                className="h-10 w-10 flex items-center justify-center border border-white/20 hover:bg-espana-red hover:border-espana-red transition-colors"
              >
                <Twitter size={18} />
              </a>
              <a
                href={SITE.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
                className="h-10 w-10 flex items-center justify-center border border-white/20 hover:bg-espana-red hover:border-espana-red transition-colors"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={SITE.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                aria-label="Facebook"
                className="h-10 w-10 flex items-center justify-center border border-white/20 hover:bg-espana-red hover:border-espana-red transition-colors"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">
              Navegación
            </h4>
            <ul className="space-y-2.5">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => scrollTo(n.id)}
                    data-testid={`footer-nav-${n.id}`}
                    className="text-sm text-white/70 hover:text-espana-gold transition-colors"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">
              Transparencia
            </h4>
            <p className="text-sm text-white/70 leading-relaxed">
              Responsable: Manuel Antonio Evangelista Piris. La confianza se gana con
              transparencia de método y fuentes públicas citadas en cada documento.
            </p>
            <a
              href={SITE.cartaPdf}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-carta"
              className="mt-4 inline-block text-sm font-bold text-espana-gold hover:underline"
            >
              Carta de Responsabilidad (PDF)
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-white/40">
          <span>© {new Date().getFullYear()} España Eficiente (E²). Todos los derechos reservados.</span>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/aviso-legal" data-testid="footer-aviso-legal" className="hover:text-espana-gold transition-colors">
              Aviso legal
            </Link>
            <Link to="/privacidad" data-testid="footer-privacidad" className="hover:text-espana-gold transition-colors">
              Privacidad
            </Link>
            <Link to="/cookies" data-testid="footer-cookies" className="hover:text-espana-gold transition-colors">
              Cookies
            </Link>
            <Link to="/baja" data-testid="footer-baja" className="hover:text-espana-gold transition-colors">
              Baja del boletín
            </Link>
            <Link to="/prensa" data-testid="footer-prensa" className="hover:text-espana-gold transition-colors">
              Prensa
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
